class BasketBlock {
  constructor() {
      this.init();
  }
  init() {
      console.log('[ BasketBlock ] init');
  }
  basketUpdate(data) {
    if ($('#goods-quantity').val()) {
    if (data.count >= 1) {
      $('#goods-quantity').val(data.count);
      $('.js-header-price').html(data.sum + '₽');
      if (!$('.js-cart-add').data('num_id')) {
      $('.js-cart-add').data('num_id',data.item.id);
      $('.js-cart-add').text('ОБНОВИТЬ');
      $('.js-cart-add').css('display','none');
      $('.js-cart-add').removeClass('button-orange');
      $('.js-cart-add').parent().append('<a href="/basket/" class="header-top__cart js-bottom-cart" onclick="ym(64417021, \'reachGoal\', \'basket_open\'); return true;">'+$('.header-top--page-cart').html()+'</a>');
	  $('.js-cart-add').parent().find('.js-card-go').show();
      var i = 0;
      $('.js-bottom-cart #goods-quantity').each(function(){
        $(this).attr('id','goods-quantity-bottom'+i);
        $(this).val(data.count);
        i++;
      })
      }
    } else {
      $('#goods-quantity').val('0');
      $('.js-header-price').html('0');
    }
  } else {
    $('.js-block__basket--wrap').prepend('<input type="number" id="goods-quantity" class="input cart__input" value="'+data.count+'" disabled="">');
    $('.js-text-basket_block').html('<p>Cумма</p><span class="js-header-price header-top__price">'+data.sum + '₽'+'</span>');
    if (!$('.js-cart-add').data('num_id')) {
    $('.js-cart-add').data('num_id',data.item.id);
    $('.js-cart-add').text('ОБНОВИТЬ');
    $('.js-cart-add').css('display','none');
    $('.js-cart-add').removeClass('button-orange');
    $('.js-cart-add').parent().append('<a href="/basket/" class="header-top__cart js-bottom-cart">'+$('.header-top--page-cart').html()+'</a>');
	$('.js-cart-add').parent().find('.js-card-go').show();
    $('.js-bottom-cart #goods-quantity').attr('id','goods-quantity-bottom');
    var i = 0;
    $('.js-bottom-cart #goods-quantity').each(function(){
      $(this).attr('id','goods-quantity-bottom'+i);
      $(this).val(data.count);
      i++;
    })
    }
  }
  }
  sumUpdate(data) {
    if (data.total_sum >= 1) {
      $('.js-total-sum').text(data.total_sum);
      $('.js-promo-sum').text(data.promo);
    } else {
      $('.js-total-sum').text('0');
      $('.js-promo-sum').text('0');
    }
  }
}

export {
  BasketBlock
}
